import * as React from "react";
import {Spin} from "../../../service/slots/history/SlotSpinHistoryService";
import {CustomTable} from "../../util/CustimizableTable";
import * as moment from "moment";

interface Props {
    spins: Spin[];
}


export class SpinHistoryTableComponent extends React.Component<Props, {}> {

    render(): JSX.Element {
        return (
        <div className="ibox float-e-margins">
            <div className="ibox-content table-overflow-x-scroll">
                <CustomTable isEnabled={() => true}
                             className="table table-striped table-bordered table-hover dataTables-example dataTable">
                    <thead>
                    <tr role="row">
                        <th>User Id</th>
                        <th>Play Id</th>
                        <th>Date</th>
                        <th>Game Id</th>
                        <th>Currency</th>
                        <th>Spin Value</th>
                        <th>Win Value</th>
                        <th>Free Spins</th>
                        <th>Gift Spin Id</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.getSpins()}
                    </tbody>
                </CustomTable>
            </div>
        </div>
        )
    }

    private getSpins(): JSX.Element[] {
        return this.props.spins.map((spin: Spin) => {
            return (
                <tr key={spin.playId}>
                    <td>{spin.userId.toString()}</td>
                    <td>{spin.playId}</td>
                    <td>{SpinHistoryTableComponent.formatTimeString(spin.date)}</td>
                    <td>{spin.gameId}</td>
                    <td>{SpinHistoryTableComponent.getCurrency(spin.currency)}</td>
                    <td>{SpinHistoryTableComponent.getValue(spin.spinValue, SpinHistoryTableComponent.getCurrency(spin.currency)).toString()}</td>
                    <td>{SpinHistoryTableComponent.getValue(spin.winValue, SpinHistoryTableComponent.getCurrency(spin.currency)).toString()}</td>
                    <td>{spin.freeSpins != undefined ? spin.freeSpins : '-'}</td>
                    <td>{spin.giftSpinId ? spin.giftSpinId : '-'}</td>
                </tr>
            );
        });
    }

    private static getCurrency(currency: number): string {
        if(currency === 4) {
            return "SC";
        } else {
            return "GC";
        }
    }

    private static formatTimeString(zonedTimeStamp: string): string {
        if (!zonedTimeStamp) return '';
        return moment(zonedTimeStamp, "YYYY-MM-DDTHH:mm:ssZ")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss UTC")
    }

    private static getValue(value: number, coinType: string): number {
        if(coinType === "SC") {
            return value / 100;
        }
        return value;
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/view/slots/SpinHistoryTableComponent.tsx